import { render, staticRenderFns } from "./Italia.vue?vue&type=template&id=43f1bb92&scoped=true&"
import script from "./Italia.vue?vue&type=script&lang=js&"
export * from "./Italia.vue?vue&type=script&lang=js&"
import style0 from "./Italia.vue?vue&type=style&index=0&id=43f1bb92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f1bb92",
  null
  
)

export default component.exports